import { Injectable } from '@angular/core';

/**
 * Counts the write requests that succeeded. A screen reads the count when a
 * dialog opens and again when it closes, and reloads only if it moved: the
 * task and appointment dialogs do not report whether they saved anything.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiMutationTrackerService {
  private _count = 0;

  record(): void {
    this._count++;
  }

  get count(): number {
    return this._count;
  }
}
